module.exports = __webpack_public_path__ + "media/images/journey-night02-9b6b7e38a8bdff146a6102f808603376.jpg";